import config from '@/config';
import { resolveUserProfileImage } from '@/utils/userProfileImage';

export const getRecommendedArtistName = (artist) =>
  artist?.artist_name?.trim() || 'Artist';

export const getRecommendedArtistImageUrl = (artist) => {
  const resolvedImage = resolveUserProfileImage(artist?.image);
  if (!resolvedImage) {
    return null;
  }

  if (
    resolvedImage.startsWith('http://')
    || resolvedImage.startsWith('https://')
    || resolvedImage.startsWith('blob:')
  ) {
    return resolvedImage;
  }

  return `${config.app.imageServiceDomain}/${encodeURI(resolvedImage)}/w=480`;
};

export const getRecommendedArtistMeta = (artist) => {
  const details = [];
  const nationality = artist?.artist_nationality?.trim?.();
  if (nationality) {
    details.push(nationality);
  }

  const birth =
    typeof artist?.artist_birth === 'number'
      ? artist.artist_birth
      : typeof artist?.artist_birth === 'string'
        ? artist.artist_birth.trim()
        : null;
  if (birth) {
    details.push(`b. ${birth}`);
  }

  return details.join(' • ');
};

export const getRecommendedArtistAvailabilityLabel = (artist) => {
  const available = Number.isFinite(artist?.available_artworks_total)
    ? Number(artist.available_artworks_total)
    : null;

  if (available === null || available <= 0) {
    return null;
  }

  return available === 1 ? '1 available artwork' : `${available} available artworks`;
};
